import firebase from "firebase/app";
import "firebase/firestore";

import getArrayOfMaxSizedSubArrays from "features/shared/functions/getArrayOfMaxSizedSubArrays";
import { FIREBASE_MAX_BATCH_SIZE } from "./constants/limits";

const batchOperations = async <T>(
    operation: (
        batch: firebase.firestore.WriteBatch,
        db: firebase.firestore.Firestore,
        currentBatchItems: T[]
    ) => Promise<void>,
    batchedItems: T[]
): Promise<void> => {
    const db = firebase.firestore();
    await Promise.all(
        getArrayOfMaxSizedSubArrays(batchedItems, FIREBASE_MAX_BATCH_SIZE).map(
            async (currentBatchItems) => {
                const batch = db.batch();
                await operation(batch, db, currentBatchItems);
                await batch.commit();
            }
        )
    );
};

export default batchOperations;
